import { fromJS } from 'immutable';
export var SET_TOP_TEN_DRIVER_LIST = 'logistic-deliver/SET_TOP_TEN_DRIVER_LIST';
export var SET_LOGS_LOGISTICS_LIST = 'logistic-deliver/SET_LOGS_LOGISTICS_LIST';
export var SET_LOGISTIC_ID = 'logistic-deliver/SET_LOGISTIC_ID';
export var SET_LOGISTIC_KEYWORD = 'logistic-deliver/SET_LOGISTIC_KEYWORD';
export var SET_LOGISTIC_SORT = 'logistic-deliver/SET_LOGISTIC_SORT';
export var SET_LOGISTIC_TOTAL = 'logistic-deliver/SET_LOGISTIC_TOTAL';
export var SET_LOGISTIC_CURRENT_PAGE = 'logistic-deliver/SET_LOGISTIC_CURRENT_PAGE';
export var SET_LOGISTIC_ROWS_PER_PAGE = 'logistic-deliver/SET_LOGISTIC_ROWS_PER_PAGE';
export var SET_DATETIME = 'logistic-deliver/SET_DATETIME';
export var SET_IS_DATETIME_CHANGE = 'logistic-deliver/SET_IS_DATETIME_CHANGE';
export var RESET = 'logistic-deliver/RESET';
export var setTopTenDriverList = function setTopTenDriverList(data) {
  return {
    type: SET_TOP_TEN_DRIVER_LIST,
    data: data
  };
};
export var setLogsLogisticsList = function setLogsLogisticsList(data) {
  return {
    type: SET_LOGS_LOGISTICS_LIST,
    data: data
  };
};
export var setLogisticId = function setLogisticId(data) {
  return {
    type: SET_LOGISTIC_ID,
    data: data
  };
};
export var setLogisticKeyword = function setLogisticKeyword(data) {
  return {
    type: SET_LOGISTIC_KEYWORD,
    data: data
  };
};
export var setLogisticSort = function setLogisticSort(sort) {
  return {
    type: SET_LOGISTIC_SORT,
    sort: sort
  };
};
export var setLogisticTotal = function setLogisticTotal(data) {
  return {
    type: SET_LOGISTIC_TOTAL,
    data: data
  };
};
export var setLogisticCurrentPage = function setLogisticCurrentPage(data) {
  return {
    type: SET_LOGISTIC_CURRENT_PAGE,
    data: data
  };
};
export var setLogisticRowsPerPage = function setLogisticRowsPerPage(data) {
  return {
    type: SET_LOGISTIC_ROWS_PER_PAGE,
    data: data
  };
};
export var setDateTime = function setDateTime(data) {
  return {
    type: SET_DATETIME,
    data: data
  };
};
export var setIsDateTimeChange = function setIsDateTimeChange(data) {
  return {
    type: SET_IS_DATETIME_CHANGE,
    data: data
  };
};
export var reset = function reset() {
  return {
    type: RESET
  };
};
var initialState = fromJS({
  topTenDriverList: [],
  logsLogisticsList: [],
  logisticId: '',
  logisticKeyword: '',
  logisticSort: {
    field: 'estBeginTime',
    desc: true
  },
  logisticRowsPerPage: 10,
  logisticCurrentPage: 0,
  logisticTotal: 0,
  // date time format: 'YYYY/MM/DD HH:MM:ss'
  dateTime: {
    from: '',
    to: ''
  },
  isDateTimeChange: true
});
export default function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case SET_TOP_TEN_DRIVER_LIST:
      return state.set('topTenDriverList', fromJS(action.data));

    case SET_LOGS_LOGISTICS_LIST:
      return state.set('logsLogisticsList', fromJS(action.data));

    case SET_LOGISTIC_ID:
      return state.set('logisticId', fromJS(action.data));

    case SET_LOGISTIC_KEYWORD:
      return state.set('logisticKeyword', fromJS(action.data));

    case SET_LOGISTIC_SORT:
      return state.set('logisticSort', fromJS(action.sort));

    case SET_LOGISTIC_TOTAL:
      return state.set('logisticTotal', fromJS(action.data));

    case SET_LOGISTIC_CURRENT_PAGE:
      return state.set('logisticCurrentPage', fromJS(action.data));

    case SET_LOGISTIC_ROWS_PER_PAGE:
      return state.set('logisticRowsPerPage', fromJS(action.data));

    case SET_DATETIME:
      return state.set('dateTime', fromJS(action.data));

    case SET_IS_DATETIME_CHANGE:
      return state.set('isDateTimeChange', fromJS(action.data));

    case RESET:
      return initialState;

    default:
      return state;
  }
}